export const FILTER_NAME = 'stock_count_report'
